// extracted by mini-css-extract-plugin
export var menu = "styles-module--menu--353Zo";
export var menuHandle = "styles-module--menu-handle--1-3P2";
export var inverted = "styles-module--inverted--84vDv";
export var menuLinks = "styles-module--menu-links--6mRli";
export var linkList = "styles-module--link-list--1Pq9-";
export var menuHeader = "styles-module--menu-header--3jisG";
export var active = "styles-module--active--3uAYX";